<template>
  <div class=''>

    <!-- <el-row class="mt20" style="">
      <el-form :model="detail" label-position="left" style="padding-left:15px;" id="detail" label-width="150px">
        <el-form-item :label="$t('lin_global.certificateName')">
          {{ detail.certificateName}}
        </el-form-item>
        <el-form-item :label="$t('lin_global.createTime')">
          {{ detail.createTime}}
        </el-form-item>
        <el-form-item :label="$t('lin_global.zdqds')">
          {{ detail.distributorName}}
        </el-form-item>
        <el-form-item :label="$t('lin_global.remark')">
          {{ detail.certificateDesc}}
        </el-form-item>
      </el-form>
    </el-row> -->

    <el-row class='gPageBorder  gPdTB' style=''>
      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_cardno') ">
            {{ detail.accountNo}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_trdno') ">
            {{ detail.traceId}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_batcno') ">
            {{ detail.batchId}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_amout') ">
            {{ detail.amout}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_mechno') ">
            {{ detail.merchId}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('lin_global.label_no') ">
            {{ detail.terminalNo}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_trdtime') ">
            {{ detail.requesTime}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_trddate') ">
            {{ detail.requestDate}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_trdcore') ">
            {{ detail.hostagentserialNo}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_expno') ">
            {{ detail.referenceNo}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_license') ">
            {{ detail.authRc}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_trdtype') ">
            {{ detail.transType}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_rectime') ">
            {{ detail.recordTime}}
          </el-form-item>
        </el-form>
      </el-col>

    </el-row>
    <div class='gPageBorder gTopMg gPdTB'>      
      <p class='gCtColor  gPTitle' style=''>{{$t('app_fpaddrs')}} </p>
      <br/>
      <div style="text-align: center">
        <!-- <img src="https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=2924172655,3990639322&fm=26&gp=0.jpg" /> -->
        <img :src='$host+detail.faceUrl' />
      </div>
    </div>
    
  </div>
</template>
<script>  
  export default{
    data() {
      return{
        currentPage: 1,
        pageSize: 10,
        totalRecords: 0,        
        arrdata:[],
        detail: ''
      }
    },
    created(){
      // this.getDetail();      
      this.detail = this.$getWObj().trade      
    },
    methods:{          
      
    }
  }
</script>



// WEBPACK FOOTER //
// trDetail.vue?0a448972